import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useDeletePoll = () => {
  const deletePoll = useCallback((id) => {
    const requestParams = {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    };

    const url = `${MONOLITH_ORIGIN}/api/v3/activity/${id}/`;
    return new Request(url, requestParams);
  }, []);
  return useRestMutation(deletePoll);
};

export default useDeletePoll;
